import { __rest } from "tslib";
import React from 'react';
import Spinner from '@atlaskit/spinner';
function getSpinnerAppearance(_a) {
    var appearance = _a.appearance, isDisabled = _a.isDisabled, isSelected = _a.isSelected;
    if (isDisabled) {
        return 'inherit';
    }
    if (isSelected) {
        return 'invert';
    }
    if (appearance === 'primary' || appearance === 'danger') {
        return 'invert';
    }
    return 'inherit';
}
export default function LoadingSpinner(_a) {
    var _b = _a.spacing, spacing = _b === void 0 ? 'default' : _b, rest = __rest(_a, ["spacing"]);
    var size = spacing === 'default' ? 'medium' : 'small';
    return React.createElement(Spinner, { size: size, appearance: getSpinnerAppearance(rest) });
}
//# sourceMappingURL=loading-spinner.js.map